/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Pack_Featured_Card_ContentInputs */

const en_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 Time Crystals, 600 coins`)
};

const ar_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie، بلورة الزمن ×30، عملة ×600`)
};

const de_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 Time Crystals, 600 Münzen`)
};

const es_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 cristales de tiempo, 600 monedas`)
};

const fr_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 Cristaux de temps, 600 Pièces`)
};

const it_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 Cristalli del Tempo, 600 Monete`)
};

const ja_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie、時の結晶 ×30、コイン ×600`)
};

const ko_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 타임 크리스탈 30개, 코인 600개`)
};

const pt_br_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 30 Cristais do Tempo, 600 Moedas`)
};

const ru_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, Кристальное Время ×30, 600 монет`)
};

const th_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, คริสตัลแห่งกาลเวลา ×30, เหรียญ ×600`)
};

const tr_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, Zaman Kristalleri ×30, 600 Jeton`)
};

const zh_cn_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie、时光宝石 ×30、金币 ×600`)
};

const zh_tw_starter_pack_featured_card_content = /** @type {(inputs: Starter_Pack_Featured_Card_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie、時光寶石 ×30、金幣 ×600`)
};

/**
* | output |
* | --- |
* | "Luminie, 30 Time Crystals, 600 coins" |
*
* @param {Starter_Pack_Featured_Card_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_pack_featured_card_content = /** @type {((inputs?: Starter_Pack_Featured_Card_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Pack_Featured_Card_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_pack_featured_card_content(inputs)
	if (locale === "ar") return ar_starter_pack_featured_card_content(inputs)
	if (locale === "de") return de_starter_pack_featured_card_content(inputs)
	if (locale === "es") return es_starter_pack_featured_card_content(inputs)
	if (locale === "fr") return fr_starter_pack_featured_card_content(inputs)
	if (locale === "it") return it_starter_pack_featured_card_content(inputs)
	if (locale === "ja") return ja_starter_pack_featured_card_content(inputs)
	if (locale === "ko") return ko_starter_pack_featured_card_content(inputs)
	if (locale === "pt_br") return pt_br_starter_pack_featured_card_content(inputs)
	if (locale === "ru") return ru_starter_pack_featured_card_content(inputs)
	if (locale === "th") return th_starter_pack_featured_card_content(inputs)
	if (locale === "tr") return tr_starter_pack_featured_card_content(inputs)
	if (locale === "zh_cn") return zh_cn_starter_pack_featured_card_content(inputs)
	return zh_tw_starter_pack_featured_card_content(inputs)
});